import { createContext, useContext } from 'react';

export const SessionContext = createContext(null);

export function useOptionalSession() {
  return useContext(SessionContext) || { currentUser: null, capabilities: {} };
}
